<template>
  <div>
    <template v-if="report.cwa_data">
      <component
        v-bind:is="currentHtmlComponent"
        v-bind:cwaData="report.cwa_data"
        v-bind:report="report"
        v-bind:imagespath="`${site_url}`"
        v-bind:userAags="aags"
      ></component>
    </template>
    <template v-else-if="view_type === 'html'">
      <component
        :key="report.images_path"
        v-bind:is="currentHtmlComponent"
        v-bind:content="report.xml_content_json"
        v-bind:imagespath="`${site_url}/storage/${report.images_path}/`"
        v-bind:issue="report.issue"
      ></component>
    </template>
  </div>
</template>

<script>
  // Insider
  import InsiderAdvisorHtmlComponent from '../insider/AdvisorHTMLComponent.vue';
  import InsiderLeadingIndicatorsComponent from '../insider/LeadingIndicators.vue';
  import InsiderThreeYearOutlookComponent from '../insider/ThreeYearOutlook.vue';
  import InsiderAdvisorAppHtmlComponent from '../insider/AdvisorAppHTMLComponent.vue';

  // TR
  import IndicatorTypeA from '../trendsreport/templates/IndicatorTypeA.vue';
  import IndicatorTypeB from '../trendsreport/templates/IndicatorTypeB.vue';
  import AtAGlance from '../trendsreport/templates/AtAGlance.vue';
  import Trends10 from '../trendsreport/templates/Trends10.vue';
  import LeadingIndicator from '../trendsreport/templates/LeadingIndicator.vue';
  import EconomicOutlook from '../trendsreport/templates/EconomicOutlook.vue';
  import ExecutiveSummary from '../trendsreport/templates/ExecutiveSummary.vue';
  import IndicatorTypes from '../trendsreport/templates/IndicatorTypes.vue';

  import IndicatorTypeATemplate from '../trendsreport/html/IndicatorTypeATemplate.vue';
  import IndicatorTypeBTemplate from '../trendsreport/html/IndicatorTypeBTemplate.vue';
  import Trends10Template from '../trendsreport/html/Trends10Template.vue';
  import LeadingIndicatorTemplate from '../trendsreport/html/LeadingIndicatorTemplate.vue';
  import EconomicOutlookTemplate from '../trendsreport/html/EconomicOutlookTemplate.vue';
  import ExecutiveSummaryTemplate from '../trendsreport/html/ExecutiveSummaryTemplate.vue';
  import AppAtAGlanceTemplate from '../trendsreport/html/AppAtAGlanceTemplate.vue';
  import AppDOSCodeTemplate from '../trendsreport/html/AppDOSCodeTemplate.vue';

  // New TR
  export default {
    props: {
      report: {
        type: Object,
        required: true,
      },
      site_url: {
        type: String,
        required: true,
      },
      template: {
        type: Object,
        required: false,
      },
      aags: {
        type: [Array, Object],
        required: false,
      },
    },
    components: {
      InsiderAdvisorHtmlComponent,
      InsiderLeadingIndicatorsComponent,
      InsiderThreeYearOutlookComponent,
      InsiderAdvisorAppHtmlComponent, //for the app
      'tr-indicator-type-a-component': IndicatorTypeA,
      'tr-indicator-type-b-component': IndicatorTypeB,
      'tr-at-a-glance-component': AtAGlance,
      'tr-global-at-a-glance-component': AtAGlance,
      'tr-trends-10-component': Trends10,
      'tr-leading-indicator-component': LeadingIndicator,
      'tr-economic-outlook-component': EconomicOutlook,
      'tr-executive-summary-component': ExecutiveSummary,
      'tr-indicator-types-component': IndicatorTypes,
      IndicatorTypeATemplate,
      IndicatorTypeBTemplate,
      Trends10Template,
      LeadingIndicatorTemplate,
      EconomicOutlookTemplate,
      ExecutiveSummaryTemplate,    
      AppAtAGlanceTemplate,
      AppDOSCodeTemplate,
    },
    data: function () {
      return {
        view_type: 'html',
        tr_cwa_mapping: {
          'tr-indicator-type-a': 'AppDOSCodeTemplate',
          'tr-indicator-type-b': 'AppDOSCodeTemplate',
          'tr-at-a-glance': 'AppAtAGlanceTemplate',
          'tr-trends-10': 'Trends10Template',
          'tr-leading-indicator': 'LeadingIndicatorTemplate',
          'tr-economic-outlook': '', // todo - waiting on business
          'tr-executive-summary': 'ExecutiveSummaryTemplate',
          'tr-indicator-types': '', // todo - do we need this?
          'tr-indicator-type-ab': '', // todo - do we need this?
          'tr-global-at-a-glance': 'AppAtAGlanceTemplate',
        },
      };
    },
    computed: {
      currentHtmlComponent: function () {
        if (this.report.cwa_data) {
          return this.tr_cwa_mapping[this.template.slug];
        }
        if (
          this.report.report_type.template.vue_component ==
          'insider-advisor-html-component'
        ) {
          return 'insider-advisor-app-html-component';
        }
        return this.report.report_type.template.vue_component;
      },
    },
  };
</script>
